import AppFrontendsIndex from "./frontend.vue";
import AppFrontendsList from "./list/list.vue";
import AppFrontendsItem from "./item/item.vue";
import AppFrontendsMyFamily from "./my-family.vue";
import AppFrontendsConfirmations from "./confirmations.vue";

const routes = [
  {
    path: "/",
    component: AppFrontendsIndex,
    children: [
      {
        path: "",
        name: "frontend.index",
        component: AppFrontendsList
      },
      {
        path: "/courseregistration/:id",
        name: "frontend.edit",
        component: AppFrontendsItem
      },
      {
        path: "/my-family",
        name: "frontend.my-family",
        component: AppFrontendsMyFamily,
        meta: {
          auth: true
        }
      },
      {
        path: "/confirmations",
        name: "frontend.confirmations",
        component: AppFrontendsConfirmations,
        meta: {
          auth: true
        }
      }
    ]
  }
];

export default routes;
